import { useContext } from 'react';

import { BasketContext } from '@/context/basketContext/basketContext';

export function useBasketContext() {
  return useContext(BasketContext);
}
